export default {
  "Cut Audio": "Cortar Áudio",
  "HitPaw Online Audio Cutter": "HitPaw Online Cortador de Áudio",
  "Trim or cut any audio files online.": "Recortar ou cortar qualquer arquivo de áudio online.",
  "Cut": "Cortar",
  "Fade in": "Fade-in",
  "Fade out": "Fade-out",
  "Cut from": "Cortar a partir de",
  "to": "para",
  "Extract selection": "Extrair a seleção",
  "Delete selection": "Eliminar a seleção",
  "Adjust New": "Ajustar Novo",
  "Cut New": "Cortar Novo",
  "Adjust Volume": "Ajustar Volume",
  "HitPaw Online Volume Changer": "HitPaw Online Controlador de Volume",
  "Turn up or Turn down the volume of audio.": "Aumentar ou diminuir o volume de áudio.",
  "Volume": "Volume",
  "Change Speed": "Mudar Velocidade",
  "HitPaw Online Audio Speed Changer": "HitPaw Online Controlador de Velocidade de Áudio",
  "Speed up or slow down audios online easily.": "Acelerar ou diminuir a velocidade dos áudios online facilmente",
  "Speed": "Velocidade",
  "Format": "Formato",
  "Size": "Tamanho",
  "Duration": "Duração",
};
